import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { PxCaptchaTypes } from "../types";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { notificationsRioEvent } from "../../lib/rio/rioEvents";
import { trigger as clientCallback } from "../../lib/clientCallback";
import { EventTypes, recordEvents } from "../../utils/newRelicEvents";
import { PxError, sendResetPasswordEmail } from '@chegg/one-auth-sdk';
import { hashEmail } from "../../utils/hashEmail";
import { getTexts } from "../../lib/contentful/defaultTexts";
import { initiatePx } from "../../utils/pxUtils";
export var sdkResetPasswordReducers = {
  rejected: function rejected(state, action) {
    var _action$payload = action.payload,
      error = _action$payload.error,
      hashedEmail = _action$payload.hashedEmail;
    var clientId = state.clientId;
    sendNotificationsRioEvent(error.code);
    if ((error === null || error === void 0 ? void 0 : error.message) !== 'px_error') {
      state.resetPassword.loading = false;
      state.resetPassword.credentials.error = getTexts().resetPassword.genericError;
      recordEvents(_defineProperty({}, EventTypes.resetPasswordFail, {
        clientId: clientId,
        email: hashedEmail,
        error: error.message ? error.message : getTexts().resetPassword.genericError,
        isCriticalError: error.criticalError
      }));
      return;
    }
  },
  pending: function pending(state) {
    state.resetPassword.loading = true;
  },
  fulfilled: function fulfilled(state) {
    state.resetPassword.loading = false;
    state.resetPassword.successScreen = true;
    state.resetPassword.credentials.error = '';
  }
};
export var sdkResetPassword = createAsyncThunk('oneauth/sdkResetPassword', /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, _ref) {
    var getState, dispatch, rejectWithValue, state, env, clientId, email, hashedEmail, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          getState = _ref.getState, dispatch = _ref.dispatch, rejectWithValue = _ref.rejectWithValue;
          state = getState();
          env = state.env, clientId = state.clientId, email = state.resetPassword.credentials.email.value;
          _context.next = 5;
          return hashEmail(email);
        case 5:
          hashedEmail = _context.sent;
          recordEvents(_defineProperty({}, EventTypes.resetPasswordStart, {
            clientId: clientId,
            email: hashedEmail
          }));
          _context.prev = 7;
          _context.next = 10;
          return sendResetPasswordEmail(clientId, email);
        case 10:
          response = _context.sent;
          recordEvents(_defineProperty({}, EventTypes.resetPasswordSuccess, {
            clientId: clientId,
            email: hashedEmail
          }));
          clientCallback({
            type: 'auth',
            payload: {
              action: 'reset_password',
              status: 'success',
              data: response
            }
          });
          _context.next = 20;
          break;
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](7);
          clientCallback({
            type: 'auth',
            payload: {
              action: 'reset_password',
              status: 'error',
              errors: _context.t0,
              data: {}
            }
          });
          if (_context.t0 instanceof PxError) {
            initiatePx(env, _context.t0, dispatch, clientId, PxCaptchaTypes.RESET_PASSWORD, 'email/password', false, function () {
              dispatch(sdkResetPassword());
            });
          }
          return _context.abrupt("return", rejectWithValue({
            error: _context.t0,
            hashedEmail: hashedEmail
          }));
        case 20:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[7, 15]]);
  }));
  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}());
function sendNotificationsRioEvent(errorCode) {
  var message_detail = getTexts().resetPassword.genericError;
  var message_id = 'reset password sdk: genericError';
  notificationsRioEvent({
    notifications: {
      message_id: message_id,
      type: 'error',
      message_detail: message_detail,
      message_name: 'reset password error'
    }
  });
}